import { render, staticRenderFns } from "./EducationalStageUpdate.vue?vue&type=template&id=6e8c2700&"
import script from "./EducationalStageUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalStageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports